import { Component } from '@angular/core';
import {MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../services/http/http.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-importazione-operatori',
  templateUrl: './importazione-operatori.component.html',
  styleUrls: ['./importazione-operatori.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    ReactiveFormsModule
  ],
  standalone: true
})
export class ImportazioneOperatoriComponent{


  constructor(
    public dialogRef: MatDialogRef<ImportazioneOperatoriComponent>,
    public dialog: MatDialog,
    private api: HttpService,
    private snackBar : MatSnackBar
  ) {}


  onClose(): void {
    this.dialogRef.close();
  }

  procedi() : void {
    this.api.etlOperatori().subscribe({
      next: (response: any) => {
        this.snackBar.open('Operatori importati con successo', 'close', { panelClass: 'successSnack' });
        this.dialogRef.close();
      }
    })
  }
}
